import { DAY, HOUR, MINUTE } from './constants';
import { overlaps } from './helpers';

const evaluateRules = ({ records, target, now, automated, contact }) => {
  const evidence = [];
  const add = (id, category, weight) => evidence.push({ id, category, weight });
  const recent = records.filter((record) => record.at <= now && record.at > now - DAY);
  const attempts = recent.filter((record) => record.kind === 'attempt' && record.at > now - 30 * MINUTE);
  const bookings = recent.filter((record) => record.kind === 'booking' && overlaps(record, target));
  const cycles = bookings.filter(
    (record) =>
      record.createdAt > now - DAY &&
      record.createdAt <= record.cancelledAt &&
      record.cancelledAt > now - DAY &&
      record.cancelledAt <= now,
  );
  const contacts = new Set(
    attempts
      .filter((record) => record.target === target.target)
      .map((record) => record.contact)
      .filter(Boolean),
  );
  if (contact) contacts.add(contact);

  if (automated) add('environmentAutomation', 'environment', 8);
  if (contacts.size >= 3) add('contactRotation', 'contact', 15);
  if (attempts.filter((record) => record.state === 'failed' && record.at > now - 10 * MINUTE).length >= 5) {
    add('confirmationRetries', 'operation', 15);
  }
  if (bookings.filter((record) => record.createdAt > now - HOUR).length >= 3) {
    add('bookingConcentration', 'bookingPattern', 20);
  }
  if (cycles.length >= 2) add('bookingCycles', 'bookingPattern', 30);
  if (cycles.filter((record) => record.target === target.target).length >= 2 && contacts.size >= 3) {
    add('linkedContactCycles', 'combination', 15);
  }

  const score = Math.max(0, 100 - evidence.reduce((total, item) => total + item.weight, 0));
  return { score, evidence };
};

export { evaluateRules };
